<template>
    <form @submit.prevent="saveRefinance()">
        <div class="row">
            <div class="col-12 text-center">
                <errors v-if="form.errors">
                    {{ form.errors[0]?.title }}
                </errors>
            </div>
            <div class="col">
                <label class="small akkurate-dark" for="marital_status">Loan Scheme <star></star></label>
                <b-form-group id="marital_status" label-for="marital_status">
                    <multiselect class="mt-2 field-container" label="name" v-model="form.scheme"
                        :options="scheme_options" :allow-empty="false"></multiselect>
                    <errors v-if="form.errors.loanproduct_id">
                        {{ form.errors.loanproduct_id[0] }}
                    </errors>
                </b-form-group>
            </div>
            <div class="col-12 col-md-4">
                <b-form-group label-for="interest_method" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="interest_method">Interest Method <star></star></label>
                    </template>
                    <multiselect v-model="form.interest_method" :options="interest_method_options" selectLabel=""
                        deselectLabel="" :show-labels="false" @select="interestMethod" class="mt-2 field-container"
                        placeholder="Pick a value">
                    </multiselect>
                    <errors v-if="form.errors.interest_method">
                        {{ form.errors.interest_method[0] }}
                    </errors>
                </b-form-group>
            </div>

            <div class="col-12 col-md-4">
                <b-form-group label-for="amount" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="amount">Amount <star></star></label>
                    </template>
                    <b-form-input id="amount" name="amount" class="mt-2 field-container fields" type="number" step="any"
                        v-model="form.principal_amount"></b-form-input>
                    <errors v-if="form.errors.principal_amount">
                        {{ form.errors.principal_amount[0] }}
                    </errors>
                </b-form-group>
            </div>

            <div class="col-12 col-md-4" v-show="hybrid">
                <b-form-group label-for="interest_rate" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="interest_rate">Interest Rate % <star></star></label>
                    </template>
                    <b-form-input id="interest_rate" name="interest_rate" class="mt-2 field-container fields"
                        type="number" v-model="form.interest_rate" step="any"></b-form-input>
                    <errors v-if="form.errors.interest_rate">
                        {{ form.errors.interest_rate[0] }}
                    </errors>

                </b-form-group>
            </div>


            <div class="col-12 col-md-4" v-show="hybrid">
                <b-form-group label-for="interest_rate_frequency" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="interest_rate_frequency">Interest Rate Frequency <star>
                            </star></label>
                    </template>
                    <multiselect v-model="form.interest_rate_frequency" :options="interest_rate_frequency_options"
                        selectLabel="" deselectLabel="" :show-labels="false" class="mt-2 field-container"
                        placeholder="Pick a value">
                    </multiselect>
                    <errors v-if="form.errors.interest_rate_frequency">
                        {{ form.errors.interest_rate_frequency[0] }}
                    </errors>
                </b-form-group>
            </div>

            <div class="col-12 col-md-4">
                <b-form-group label-for="interest_start_date" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="interest_start_date">Interest Start Date <star></star>
                        </label>
                    </template>
                    <b-form-input id="interest_start_date" name="interest_start_date"
                        class="mt-2 field-container fields" type="date"
                        v-model="form.interest_start_date"></b-form-input>
                    <errors v-if="form.errors.interest_start_date">
                        {{ form.errors.interest_start_date[0] }}
                    </errors>
                </b-form-group>
            </div>

            <!-- <div class="col-12 col-md-4" v-show="straight_line">
                <b-form-group label-for="expected_interest" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="expected_interest">Expected Interest <star></star>
                        </label>
                    </template>
                    <b-form-input id="expected_interest" name="expected_interest" class="mt-2 field-container fields" type="number" v-model="form.expected_interest" step="any"></b-form-input>
                    <errors v-if="form.errors.expected_interest">
                        {{ form.errors.expected_interest[0] }}
                    </errors>
                </b-form-group>
            </div> -->

            <!-- <div class="col-12 col-md-4" v-show="straight_line">
                <b-form-group label-for="fixed_interest_rate" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="fixed_interest_rate">Fixed Interest Rate <star></star>
                        </label>
                    </template>
                    <b-form-input id="fixed_interest_rate" name="fixed_interest_rate" class="mt-2 field-container fields" type="number" step="any" v-model="form.fixed_interest_rate"></b-form-input>
                    <errors v-if="form.errors.fixed_interest_rate">
                        {{ form.errors.fixed_interest_rate[0] }}
                    </errors>
                </b-form-group>
            </div> -->

            <!-- <div class="col-12 col-md-4" v-show="straight_line">
                <b-form-group label-for="fixed_interest_rate_frequency" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="fixed_interest_rate_frequency">Fixed Interest Rate
                            Frequency <star></star></label>
                    </template>
                    <multiselect v-model="form.fixed_interest_rate_frequency" :options="fixed_interest_rate_frequency_options" selectLabel="" deselectLabel="" :show-labels="false" class="mt-2 field-container" placeholder="Pick a value">
                    </multiselect>
                    <errors v-if="form.errors.fixed_interest_rate_frequency">
                        {{ form.errors.fixed_interest_rate_frequency[0] }}
                    </errors>
                </b-form-group>

            </div> -->

            <!-- <div class="col-12 col-md-4" v-show="straight_line">
                <b-form-group label-for="fixed_interval" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="fixed_interval">Fixed Interval <star></star></label>
                    </template>
                    <multiselect v-model="form.fixed_interval" :options="fixed_interval_options" selectLabel="" deselectLabel="" :show-labels="false" class="mt-2 field-container" placeholder="Pick a value">
                    </multiselect>
                    <errors v-if="form.errors.fixed_interval">
                        {{ form.errors.fixed_interval[0] }}
                    </errors>
                </b-form-group>
            </div> -->

            <!-- <div class="col-12 col-md-4" v-show="straight_line">
                <b-form-group label-for="fixed_duration" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="fixed_duration">Fixed Duration<star></star></label>
                    </template>
                    <b-form-input id="fixed_duration" name="fixed_duration" class="mt-2 field-container fields" type="number" v-model="form.fixed_duration"></b-form-input>
                    <errors v-if="form.errors.fixed_duration">
                        {{ form.errors.fixed_duration[0] }}
                    </errors>
                </b-form-group>
            </div> -->
            <!-- 
            <div class="col-12 col-md-4" v-show="straight_line">
                <b-form-group label-for="fixed_duration" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="variable_interest_rate">Variable Interest Rate<star>
                            </star></label>
                    </template>
                    <b-form-input id="variable_interest_rate" name="variable_interest_rate" class="mt-2 field-container fields" type="number" v-model="form.variable_interest_rate"></b-form-input>
                    <errors v-if="form.errors.variable_interest_rate">
                        {{ form.errors.variable_interest_rate[0] }}
                    </errors>
                </b-form-group>
            </div> -->

            <!-- <div class="col-12 col-md-4" v-show="straight_line">
                <b-form-group label-for="variable_interest_rate_frequency" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="variable_interest_rate_frequency">Variable Interest Rate
                            Frequency <star></star></label>
                    </template>
                    <multiselect v-model="form.variable_interest_rate_frequency" :options="variable_interest_rate_frequency_options" selectLabel="" deselectLabel="" :show-labels="false" class="mt-2 field-container" placeholder="Pick a value">
                    </multiselect>
                    <errors v-if="form.errors.variable_interest_rate_frequency">
                        {{ form.errors.variable_interest_rate_frequency[0] }}
                    </errors>
                </b-form-group>
            </div> -->

            <!-- <div class="col-12 col-md-4" v-show="straight_line">
                <b-form-group label-for="variable_interval" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="variable_interval">Variable Interval <star></star>
                        </label>
                    </template>
                    <multiselect v-model="form.variable_interval" :options="variable_interval_options" selectLabel="" deselectLabel="" :show-labels="false" class="mt-2 field-container" placeholder="Pick a value">
                    </multiselect>
                    <errors v-if="form.errors.variable_interval">
                        {{ form.errors.variable_interval[0] }}
                    </errors>
                </b-form-group>

            </div> -->

            <!-- <div class="col-12 col-md-4" v-show="straight_line">
                <b-form-group label-for="variable_duration" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="variable_duration">Variable Duration <star></star>
                        </label>
                    </template>
                    <b-form-input id="variable_duration" name="variable_duration" class="mt-2 field-container fields" type="number" v-model="form.variable_duration"></b-form-input>
                    <errors v-if="form.errors.variable_duration">
                        {{ form.errors.variable_duration[0] }}
                    </errors>
                </b-form-group>
            </div> -->

            <div class="col-12 col-md-4">
                <label class="akkurate-dark small">Tenure <star></star></label>
                <b-form-group>
                    <b-form-input id="tenor" name="tenor" class="mt-2 field-container fields" type="number"
                        v-model="form.tenor"></b-form-input>
                    <errors v-if="form.errors.tenor">
                        {{ form.errors.tenor[0] }}
                    </errors>
                </b-form-group>
            </div>

            <div class="col-12 col-md-4">
                <b-form-group label-for="tenor_interval" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="tenor_interval">Tenure Interval <star></star></label>
                    </template>
                    <multiselect v-model="form.tenor_interval" :options="tenor_interval_options" selectLabel=""
                        deselectLabel="" :show-labels="false" class="mt-2 field-container" placeholder="Pick a value">
                    </multiselect>
                    <errors v-if="form.errors.tenor_interval">
                        {{ form.errors.tenor_interval[0] }}
                    </errors>
                </b-form-group>
            </div>

            <div class="col-12 col-md-4">
                <b-form-group label-for="repayment_cycle" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="repayment_cycle">Repayment Cycle <star></star></label>
                    </template>
                    <multiselect v-model="form.repayment_cycle" :options="repayment_cycle_options" selectLabel=""
                        deselectLabel="" :show-labels="false" class="mt-2 field-container" placeholder="Pick a value">
                    </multiselect>
                    <errors v-if="form.errors.repayment_cycle">
                        {{ form.errors.repayment_cycle[0] }}
                    </errors>
                </b-form-group>
            </div>

            <!-- <div class="col-12 col-md-4">
                <b-form-group label-for="maturity_date" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="maturity_date">Maturity Date</label>
                    </template>
                    <b-form-input disabled id="maturity_date" name="maturity_date" v-model="form.maturity_date"
                        class="mt-2 field-container fields" type="date"></b-form-input>
                    <errors v-if="form.errors.maturity_date">
                        {{ form.errors.maturity_date[0] }}
                    </errors>
                </b-form-group>
            </div> -->

            <div class="col-12 col-md-4">
                <b-form-group label-for="penalty_rate" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="penalty_rate">Penalty Rate <star></star></label>
                    </template>
                    <b-form-input id="penalty_rate" name="penalty_rate" class="mt-2 field-container fields"
                        type="number" v-model="form.penalty_rate"></b-form-input>
                    <errors v-if="form.errors.penalty_rate">
                        {{ form.errors.penalty_rate[0] }}
                    </errors>
                </b-form-group>
            </div>

            <div class="col-12 col-md-4">
                <b-form-group label-for="no_of_payment" class="mb-3">
                    <template #label>
                        <label class="akkurate-dark small" for="reason">Reason <star></star></label>
                    </template>
                    <b-form-textarea class="mt-2 fields" id="reason" style="height: 36px !important;"
                        v-model="form.reason" placeholder="Enter Reason..."></b-form-textarea>
                    <errors v-if="form.errors.reason">
                        {{ form.errors.reason[0] }}
                    </errors>
                </b-form-group>
            </div>

            <div class="col-12 col-md-4">
                <label class="akkurate-dark small" for="lpp_type">LPP Type</label>
                <b-form-group id="lpp_type" name="lpp_type" label-for="lpp_type" :description="lpp_description">
                    <multiselect id="lpp_type" name="lpp_type" class="mt-2 field-container" @select="selectLPP"
                        label="name" v-model="form.lpp_type" :options="lpp_type_options">
                    </multiselect>
                </b-form-group>
                <b-form-invalid-feedback>
                    {{ veeErrors.first('lpp_type') }}
                </b-form-invalid-feedback>
            </div>
            <div class="col-12 col-md-4">
                <b-form-group label-for="lpp_value" :description="interest_expected_description">
                    <template #label>
                        <label class="akkurate-dark small" for="lpp_value">LPP Value <star></star></label>
                    </template>
                    <b-form-input id="lpp_value" name="lpp_value" class="mt-2 field-container fields" type="text"
                        v-model="form.lpp_value" disabled></b-form-input>
                    <errors v-if="form.errors.lpp_value">
                        {{ form.errors.lpp_value[0] }}
                    </errors>
                </b-form-group>
            </div>
            <div class="col-12 col-md-4">
                <b-form-group label-for="lpf_value" :description="loan_lpf_description">
                    <template #label>
                        <label class="akkurate-dark small" for="lpf_value">LPF Value <star></star></label>
                    </template>
                    <b-form-input id="lpf_value" name="lpf_value" class="mt-2 field-container fields" type="text"
                        v-model="form.lpf_value" disabled></b-form-input>
                    <errors v-if="form.errors.lpf_value">
                        {{ form.errors.lpf_value[0] }}
                    </errors>
                </b-form-group>
            </div>
            <div class="col-12 col-md-4">
                <b-form-group label-for="other_charges_description">
                    <template #label>
                        <label class="akkurate-dark small" for="other_charges_description">Other Charges
                            (Description)</label>
                    </template>
                    <b-form-input id="other_charges_description" name="other_charges_description"
                        class="mt-2 field-container fields" type="text"
                        v-model="form.other_charges_description"></b-form-input>
                    <errors v-if="form.errors.other_charges_description">
                        {{ form.errors.other_charges_description[0] }}
                    </errors>
                </b-form-group>
            </div>
            <div class="col-12 col-md-4">
                <b-form-group label-for="other_charges">
                    <template #label>
                        <label class="akkurate-dark small" for="other_charges">Other Charges (Fee)</label>
                    </template>
                    <b-form-input id="other_charges" name="other_charges" class="mt-2 field-container fields"
                        type="text" v-model="form.other_charges"></b-form-input>
                    <errors v-if="form.errors.other_charges">
                        {{ form.errors.other_charges[0] }}
                    </errors>
                </b-form-group>
            </div>
            <div class="col-12 col-md-2">
                <b-form-group>
                    <template #label>
                        <label class="akkurate-dark" for="automatic_set_off">Automatic Set Off <star></star></label>
                    </template>
                    <b-form-radio v-model="form.automatic_set_off" name="automatic_set_off" value="1">Yes</b-form-radio>
                    <b-form-radio v-model="form.automatic_set_off" name="automatic_set_off" value="0">No</b-form-radio>
                    <errors v-if="form.errors.automatic_set_off">
                        {{ form.errors.automatic_set_off[0] }}
                    </errors>
                </b-form-group>
            </div>

            <div class="text-end py-3">
                <b-button @click="clearForm" class="akkurate-gray-btn me-2 btn-size"><font-awesome-icon class="me-2"
                        :icon="['fas', 'close']" />Clear</b-button>
                <button type="submit" :disabled="isSaving"
                    class="btn akkurate-green-btn text-white btn-size me-2"><font-awesome-icon class="me-2"
                        :icon="['fas', 'save']" />{{ save }}</button>

            </div>

        </div>
    </form>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
export default {
    components: {
        Multiselect
    },
    props: ['loan', 'scheme_options'],
    // mounted() {
    //     this.getScheme();
    // },
    data() {
        return {
            ...this.initialState(),
            interest_method_options: ["straight-line", "reducing-balance", "hybrid"],
            interest_rate_frequency_options: ['Daily', 'Weekly', 'Monthly', 'Annually'],
            fixed_interest_rate_frequency_options: ['Daily', 'Weekly', 'Monthly', 'Annually'],
            fixed_interval_options: ['Days', 'Weeks', 'Months', 'Years'],
            variable_interest_rate_frequency_options: ['Daily', 'Weekly', 'Monthly', 'Annually'],
            variable_interval_options: ['Days', 'Weeks', 'Months', 'Years'],
            tenor_interval_options: ['Days', 'Weeks', 'Months', 'Years'],
            repayment_cycle_options: ['Daily', 'Weekly', 'Monthly', 'Annually'],

            straight_line: false,
            reducing_balance: false,
            hybrid: true,
            save: "Save",
            isSaving: false,
            error_message: "",
        }
    },
    methods: {
        async saveRefinance() {
            // console.log(this.loan);
            this.isSaving = true;
            this.$Progress.start();
            this.save = "Saving..."
            let form = {
                'loan_number': this.loan?.loan_number,
                'loanproduct_id': this.form?.scheme?.id,
                'principal_amount': this.form.principal_amount,
                'interest_method': this.form.interest_method,
                'interest_start_date': this.form.interest_start_date,
                'expected_interest': this.form.expected_interest,
                'repayment_cycle': this.form.repayment_cycle,
                'maturity_date': this.form.maturity_date,
                'penalty_rate': this.form.penalty_rate,
                'reason': this.form.reason,
                'credit_officer': this.form.credit_officer,
                'recovery_officer': this.form.recovery_officer,
                'source': this.form.source,
                'lpp_type': this.form.lpp_type?.cua_standard,
                'lpp_value': this.form.lpp_value,
                'lpf_value': this.form.lpf_value,
                'automatic_set_off': this.form.automatic_set_off,
                'tenor': this.form?.tenor,
                'tenor_interval': this.form?.tenor_interval,
                'interest_rate': this.form?.interest_rate,
                'interest_rate_frequency': this.form?.interest_rate_frequency,
                'source': "OFFICE"
            }
            await ApiService.post('/loans/loanRefinancing', form)
                .then((response) => {
                    this.isSaving = false;
                    this.$Progress.finish();
                    this.save = "Save"
                    toast.fire({
                        icon: "success",
                        title: response.data.message,
                    });
                    // let loan_id = response.data?.data?.id;
                    this.$emit('refreshRefinancing');
                    this.form = this.initialState().form;


                }).catch((error) => {
                    this.isSaving = false;
                    this.$Progress.finish();
                    this.save = "Save"
                    console.log(error.response.data.errors);
                    if (error.response.data.errors) {
                        this.form.errors = error.response.data.errors;
                    }
                });
        },

        initialState() {
            return {
                form: {
                    loan_number: "",
                    account_number: "",
                    loanproduct_id: "",
                    interest_method: "straight-line", // ['straight_line', 'reducing-balance', 'hybrid']
                    principal_amount: "",
                    interest_rate: "",
                    interest_rate_frequency: "", // ['Daily', 'Weekly', 'Monthly', 'Annually']
                    interest_start_date: "",
                    expected_interest: "",
                    fixed_interest_rate: "",
                    fixed_interest_rate_frequency: "", //['Daily', 'Weekly', 'Monthly', 'Annually']
                    fixed_interval: "", //['Days', 'Weeks', 'Months', 'Years']
                    fixed_duration: "",
                    variable_interest_rate: "",
                    variable_interest_rate_frequency: "", //['Daily', 'Weekly', 'Monthly', 'Annually']
                    variable_interval: "", //['Days', 'Weeks', 'Months', 'Years']
                    variable_duration: "",
                    tenor: "", // integer 
                    tenor_interval: "", //['Days', 'Weeks', 'Months', 'Years']
                    repayment_cycle: "", // ['Daily', 'Weekly', 'Monthly', 'Annually']
                    maturity_date: "",
                    penalty_rate: "", // Penalty fee
                    reason: "",
                    credit_officer: 1, // "User ID"
                    recovery_officer: 2, // "User ID"
                    lpp_type: "",
                    lpp_value: "",
                    lpf_value: "",
                    other_charges_description: "",
                    automatic_set_off: "0",
                    other_charges: "",
                    source: "OFFICE",
                    // insurance: "", // integer
                    // supervisor_approval_limit: "", // integer
                    // branch_approval_limit: "", // integer
                    errors: [],
                },
                lpp_type_options: [
                    { id: 'cua_standard', name: 'CUA STANDARD' },
                    { id: 'insure_interest', name: 'INSURE INTEREST' },
                    { id: 'custom', name: 'CUSTOM' }
                ],
                lpp_description: "",
                interest_expected_description: "",
                loan_lpf_description: "",
                loan_calulator: {
                    total_payment: "",
                    total_interest: "",
                    interest_rate: "",
                    interest_rate_per_interval: "",
                    daily_interest_amount: "",
                    daily_interest: "",
                    principal_amount: "",
                    number_of_payments: "",
                    payment: "",
                }

            }
        },
        clearForm() {
            this.form = this.initialState().form; // Call the initialState method to get the default form
        },
        interestMethod(value) {
            // console.log(value);
            switch (value) {
                case 'straight-line':
                    this.straight_line = false;
                    this.hybrid = true;
                    break;
                case 'reducing-balance':
                    this.straight_line = true;
                    this.hybrid = true;
                    break;
                case 'hybrid':
                    this.straight_line = true;
                    this.hybrid = false;
                    break;
            }
        },
        selectLPP(value) {
            // console.log(this.loan);
            this.form.lpp_value = "";
            let lpp = this.form?.scheme?.loan_premium_plan;
            let lpf = this.form?.scheme?.loan_processing_fee;
            this.calculateLoans();
            let principal = this.form.principal_amount ?? 0;
            let principal_interest = Number(principal) + Number(this.loan_calulator.total_interest);
            if (this.form?.principal_amount != 0 && this.form?.tenor != "" && this.form?.tenor_interval != "") {
                switch (value.id) {
                    case 'cua_standard':
                        this.lpp_description = "Principal * Nò of Month/1000"
                        this.interest_expected_description = ""
                        // console.log(this.lppMonths())
                        this.form.lpp_value = principal * (this.loan_calulator?.number_of_payments / 1000);
                        break;
                    case 'insure_interest':
                        // console.log('Tenor Pecentage', tenor_pecent);
                        // console.log('Expected Interest', expected_interest);
                        this.interest_expected_description = "Expected Interest : " + this.loan_calulator.total_interest;
                        this.lpp_description = "Principal + Interest * Nò of Month/1000"
                        this.form.lpp_value = principal_interest * (this.loan_calulator?.number_of_payments / 1000);
                        break;
                    case 'custom':
                        this.lpp_description = "Principal * loan_premium_plan %"
                        this.form.lpp_value = principal * (lpp / 100)
                        this.interest_expected_description = "Loan Premium plan : " + lpp + "%"
                        break;
                }
                this.form.lpf_value = principal * (lpf / 100);
                this.loan_lpf_description = "Loan Processing fees : " + lpf + "%"

            }

        },
        async calculateLoans() {
            this.isLoading = true
            this.isCalculating = true,
                this.calculate = "Processing..."

            this.term_rows = [];
            this.repayment_rows = [];

            await ApiService.post('/loans/loanCalculator', this.form)
                .then(response => {
                    this.loan_calulator = response.data?.data
                }).catch((error) => {
                });
        }
    },
}
</script>